<div class="input-group input-group-sm">
    <span class="input-group-addon"><span class="glyphicon glyphicon-globe" aria-hidden="true"></span></span>
    <select class="form-control" [ngModel]="selectedLanguage" (ngModelChange)="setLanguage($event)"
            attr.aria-label="{{'LANGUAGE'|translate}}">
        <option *ngFor="let language of languages" [ngValue]="language[0]">{{language[1]}}</option>
    </select>
</div>
